import { ref } from 'vue';

export const useMediaQuery = () => {
    const isSp = ref(false);
    const isTb = ref(false);
    const isPrint = ref(false);

    const watchMediaQuery = () => {
        const tbMediaQuery = window.matchMedia('(max-width: 1000px)');
        tbMediaQuery.addEventListener('change', (e) => {
            isTb.value = e.matches;
        });
        isTb.value = tbMediaQuery.matches;

        const spMediaQuery = window.matchMedia('(max-width: 768px)');
        spMediaQuery.addEventListener('change', (e) => {
            isSp.value = e.matches;
        });

        const printMediaQuery = window.matchMedia('print');
        printMediaQuery.addEventListener('change', (e) => {
            isPrint.value = e.matches;
        });

        isSp.value = spMediaQuery.matches;
    };

    return {
        isSp,
        isTb,
        isPrint,
        watchMediaQuery,
    };
};
